import type { App, Plugin } from "vue";
// Import vue components
import * as components from "./components";

export default {
  install: (app: App) => {
    Object.entries(components).forEach(([componentName, component]) => {
      app.component(componentName, component);
    });
  },
} as Plugin;

export * from "./components";
export * from "./models";
export * from "./controls-theme";
